import React, { useEffect } from "react";
import { Routes, Route} from "react-router-dom";
import SideBar, { SideButton } from "../../components/organismes/SideBar/SideBar";

import useUserAuth from "../../features/auth/hook/useUserAuth";

import homeRoutes from "../../navigation/homeRoutes";
import { useLayoutContext } from "../../utils/LayoutContext/LayoutContext";
import { useQueryClient } from "@tanstack/react-query";


const routesList = homeRoutes

const sideBarButtonList : SideButton[] = routesList.reduce<SideButton[]>((listSideBarBtn,route) =>{
  if(route.isInSideBar){
    return [...listSideBarBtn,
      {
        path: route.path,
        name: route.name
      }
    ]
  }else{
    return listSideBarBtn
  }

},[])

export const Home = () => {

  let hidesidebar  = useLayoutContext().isNoSideBar;
  const queryClient = useQueryClient();
  const SHOW_NAV = process.env.REACT_APP_NAV_MODE === 'NAV'

  const {authenticateByURL
  } =useUserAuth()
  useEffect(() => {
      authenticateByURL();
      queryClient.clear();
      queryClient.refetchQueries();
  }, []) //eslint-disable-line


  return (
    <>
      <div style={{ display: "flex", height: "100vh" }}>
      {!hidesidebar && SHOW_NAV &&

    
        <div
          style={{
            padding: "10px",
            width: "100px",
            background: "#f0f0f0",
            marginRight: 15
          }}
        >

          <SideBar sideButtonList={sideBarButtonList} />

        </div>
      }
        <div style={{ flex: 1, height: "100%"}}>
          
  
            <Routes>
              {routesList.map((route, index) =>{
                return (
                <Route key={index} path={route.path} element={<route.main />} />)
}
)}
            </Routes>
          
        </div>
      </div>
    
    </>
  );
};

export default Home;
